import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import useSnackbar from '../hooks/useSnackbar';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars() {
  const bar = useSelector(state => state.snackbar);
  const snackbar = useSnackbar();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
   
    snackbar.hide();
  };

  return (
    <Stack spacing={2} className="w-full">
      <Snackbar open={bar.show} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={bar.severity || 'info'} className="w-full">
          {bar.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
